import httpClient from './httpClient';

const base = '/api/sesion-bloques';

const getAuthHeader = () => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const listarBloques            = (sesion_id)    => httpClient.get(`${base}?sesion_id=${sesion_id}`);
export const crearBloqueMasivo        = (data)         => httpClient.post(`${base}/masivo`, data);
export const crearBloque              = (data)         => httpClient.post(base, data);
export const actualizarBloque         = (id, data)     => httpClient.put(`${base}/${id}`, data);
export const eliminarBloque           = (id)           => httpClient.del(`${base}/${id}`);
export const listarMateriasCronograma = (promocion_id) => httpClient.get(`${base}/materias/${promocion_id}`);
export const obtenerCronograma        = (promocion_id) => httpClient.get(`${base}/cronograma/${promocion_id}`);
export const obtenerInvitacionesDocentes = (promocion_id) => httpClient.get(`${base}/invitaciones-docentes/${promocion_id}`);
export const reenviarInvitacionesDocentes = (promocion_id, docente_ids) =>
  httpClient.post(`${base}/invitaciones-docentes/${promocion_id}/reenviar`, { docente_ids });

const _descargar = async (url, nombreDefault) => {
  const res = await fetch(`${httpClient.baseUrl}${url}`, {
    method: 'GET',
    headers: { ...getAuthHeader() },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.message || 'Error al descargar archivo.');
  }
  const disposition = res.headers.get('content-disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const nombre = (match && match[1]) ? match[1] : nombreDefault;
  const blob = await res.blob();
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = nombre;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(link.href), 750);
};

export const actualizarAsistenciaBloque = (bloque_id, asistio) =>
  httpClient.put(`${base}/${bloque_id}/asistencia`, { asistio });

export const actualizarEstadoSesion = (sesion_id, estado, motivo) =>
  httpClient.put(`${base}/sesion/${sesion_id}/estado`, { estado, motivo });

export const descargarCronogramaPDF = (promocion_id) =>
  _descargar(`${base}/cronograma/${promocion_id}/pdf`, `Cronograma-${promocion_id}.pdf`);

export const descargarCronogramaExcel = (promocion_id) =>
  _descargar(`${base}/cronograma/${promocion_id}/excel`, `Cronograma-${promocion_id}.xlsx`);
